function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/*
 * Widgets.MarkdownEditor
 *
 * A tiny WYSIWYG editor that reads and writes plain Markdown instead of HTML.
 * The editing surface is a contenteditable element, but `value` always gets and
 * sets Markdown, limited to a small dialect:
 *
 *     **bold**            <strong>
 *     *italic*            <em>
 *     ~~strikethrough~~   <del>
 *     ++underline++       <u>
 *     - item              <ul><li>
 *     1. item             <ol><li>
 *
 * Paragraphs are separated by blank lines, single newlines become soft breaks.
 * Anything else (raw HTML, tables, links, images, headings) is not supported:
 * pasted content is reduced to plain text and unsupported markup is stripped
 * when the value is serialized back to Markdown.
 *
 * The editor looks like a regular field; the formatting toolbar pops up as a
 * small tooltip above the caret or the current text selection. The popup is
 * self-contained (no tippy or other positioning library).
 */

Widgets.MarkdownEditor = Class.create(Widgets.Base, {
  name: 'markdowneditor',
  defaults: {
    value: '',
    name: null,
    label: null,
    description: null,
    style: null,
    placeholder: null,
    width: null,
    height: null,
    lines: 4,
    enabled: true,
    onChange: null,
    onFocus: null
  },
  css: `

        .widget.markdowneditor .editor {
            border: 1px solid var(--field-border);
            background: var(--field-background);
            border-radius: 2px;
            margin: 2px 0;
            -webkit-user-select: text;
            user-select: text;
            box-sizing: border-box;
            padding: 5px;
            font-size: 13px;
            line-height: 17.6px;
            outline: none;
            overflow-y: auto;
            cursor: text;
        }

        .widget.markdowneditor .editor:empty::before {
            content: attr(data-placeholder);
            color: #888;
            font-size: 11px;
            font-style: italic;
            pointer-events: none;
        }

        .widget.markdowneditor .editor p {
            margin: 0 0 0.6em;
        }
        .widget.markdowneditor .editor p:last-child {
            margin-bottom: 0;
        }

        .widget.markdowneditor .editor ul,
        .widget.markdowneditor .editor ol {
            margin: 0.6em 0;
            padding: 0 0 0 1.4em;
        }
        .widget.markdowneditor .editor li {
            margin: 0 0 0.3em;
        }

        .widget.markdowneditor.disabled .editor {
            opacity: 0.5;
        }

        /* The toolbar lives in a body-level, fixed-position popup */
        .markdowneditor-popup {
            position: fixed;
            z-index: 9999;
            padding: 5px;
            background: #fff;
            color: #000;
            border-radius: 5px;
            filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3)) drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2));
            opacity: 0;
            visibility: hidden;
            transform: translateY(4px);
            transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out, visibility 0.15s;
        }

        .markdowneditor-popup.visible {
            opacity: 1;
            visibility: visible;
            transform: none;
        }

        .markdowneditor-popup::after {
            content: '';
            position: absolute;
            left: var(--arrow-left, 50%);
            margin-left: -6px;
            border: 6px solid transparent;
        }

        .markdowneditor-popup[data-placement=top]::after {
            top: 100%;
            border-top-color: #fff;
            border-bottom-width: 0;
        }

        .markdowneditor-popup[data-placement=bottom]::after {
            bottom: 100%;
            border-bottom-color: #fff;
            border-top-width: 0;
        }

        .markdowneditor-toolbar {
            display: flex;
            align-items: center;
            gap: 2px;
        }

        .markdowneditor-toolbar button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 26px;
            height: 24px;
            padding: 0;
            border: none;
            border-radius: 3px;
            background: none;
            color: inherit;
            font-size: 13px;
            line-height: 1;
            cursor: pointer;
        }

        .markdowneditor-toolbar button:hover {
            background: var(--button-hover-background);
        }

        .markdowneditor-toolbar button.active {
            background: var(--button-active-background);
        }

        .markdowneditor-toolbar button svg {
            fill: currentColor;
        }

        .markdowneditor-toolbar .separator {
            width: 1px;
            height: 18px;
            margin: 0 4px;
            background: var(--field-border);
        }

    `,
  buttons: [{
    command: 'bold',
    shortcut: 'Ctrl+B',
    label: '<span style="font-weight: bold;">B</span>'
  }, {
    command: 'italic',
    shortcut: 'Ctrl+I',
    label: '<span style="font-style: italic;">I</span>'
  }, {
    command: 'underline',
    shortcut: 'Ctrl+U',
    label: '<span style="text-decoration: underline;">U</span>'
  }, {
    command: 'strikeThrough',
    shortcut: 'Ctrl+Shift+X',
    label: '<span style="text-decoration: line-through;">S</span>'
  }, {
    separator: true
  }, {
    command: 'insertUnorderedList',
    shortcut: 'Ctrl+Shift+8',
    label: `
            <svg viewBox="0 0 16 16" width="14" height="14">
                <circle cx="2" cy="3" r="1.4"/><rect x="6" y="2.2" width="9" height="1.6" rx="0.8"/>
                <circle cx="2" cy="8" r="1.4"/><rect x="6" y="7.2" width="9" height="1.6" rx="0.8"/>
                <circle cx="2" cy="13" r="1.4"/><rect x="6" y="12.2" width="9" height="1.6" rx="0.8"/>
            </svg>`
  }, {
    command: 'insertOrderedList',
    shortcut: 'Ctrl+Shift+7',
    label: `
            <svg viewBox="0 0 16 16" width="14" height="14">
                <text x="0" y="4.8" font-size="5.5" font-family="sans-serif">1</text><rect x="6" y="2.2" width="9" height="1.6" rx="0.8"/>
                <text x="0" y="9.8" font-size="5.5" font-family="sans-serif">2</text><rect x="6" y="7.2" width="9" height="1.6" rx="0.8"/>
                <text x="0" y="14.8" font-size="5.5" font-family="sans-serif">3</text><rect x="6" y="12.2" width="9" height="1.6" rx="0.8"/>
            </svg>`
  }],
  initWidget: function () {
    try {
      document.execCommand('defaultParagraphSeparator', false, 'p');
      document.execCommand('styleWithCSS', false, false);
    } catch (e) {}
    this.toolbar = new Element('div', {
      'class': 'markdowneditor-toolbar'
    });
    this._buttons = {};
    this.buttons.forEach(definition => {
      if (definition.separator) {
        this.toolbar.appendChild(new Element('div', {
          'class': 'separator'
        }));
        return;
      }
      var button = new Element('button', {
        type: 'button',
        title: definition.shortcut
      });
      button.innerHTML = definition.label;
      button.tabIndex = -1;
      button.observe('mousedown', e => e.preventDefault());
      button.observe('click', this.execute.bind(this, definition.command));
      this.toolbar.appendChild(button);
      this._buttons[definition.command] = button;
    });

    /* Field-compatible structure: reuse the field layout and label CSS */
    this.classList.add('field');
    if (this.options.name) {
      this.dataset.name = this.options.name;
    }
    if (this.options.style) {
      this.classList.add(this.options.style + 'Style');
    }
    if (this.options.width) {
      this.setStyle({
        width: this.options.width
      });
    }
    if (this.options.label) {
      this.label = new Element('label').update(this.options.label);
      this.appendChild(this.label);
    }
    var wrapper = new Element('div');
    this.insert(wrapper);
    this.editor = new Element('div', {
      'class': 'editor'
    });
    this.editor.contentEditable = 'true';

    /* Sized like a regular field: `lines` behaves like a textarea's rows
       (17.6px per line plus the 5px padding), `height` is fixed and the
       content scrolls */
    if (this.options.height) {
      this.editor.style.height = this.options.height;
    } else {
      this.editor.style.minHeight = this.options.lines * 17.6 + 10 + 'px';
    }
    this.editor.innerHTML = this.markdownToHtml(this.options.value);
    wrapper.appendChild(this.editor);
    if (this.options.description) {
      wrapper.appendChild(new Element('span', {
        'class': 'description'
      }).update(this.options.description));
    }
    if (this.options.placeholder) {
      this.editor.dataset.placeholder = this.options.placeholder;
    }

    /* A click brings the toolbar back after it was hidden while typing */
    this.editor.observe('mousedown', () => {
      this._typing = false;
    });
    this.editor.observe('keydown', this.onKeyDown.bindAsEventListener(this));
    this.editor.observe('paste', this.onPaste.bindAsEventListener(this));
    this.editor.observe('input', this.onInput.bindAsEventListener(this));
    this.editor.observe('focus', () => {
      if (this.options.onFocus) this.options.onFocus();
      this.onSelectionChange();
    });
    this.editor.observe('blur', this.onBlur.bindAsEventListener(this));

    /* Not appended to the body until the first show: CSS.insert flushes
       on the next animation frame, so inserting it here would paint one
       unstyled frame when the widget is created inside a rAF callback */
    this.popup = new Element('div', {
      'class': 'markdowneditor-popup'
    });
    this.popup.appendChild(this.toolbar);
    this.popup.observe('mousedown', e => e.preventDefault());
    this._popupVisible = false;
    this._typing = false;
    this._selectionListener = this.onSelectionChange.bind(this);
    document.addEventListener('selectionchange', this._selectionListener);
    this._repositionListener = () => {
      if (this._popupVisible) this.reposition();
    };
    window.addEventListener('scroll', this._repositionListener, true);
    window.addEventListener('resize', this._repositionListener);
    this.defineProperty('value', {
      get: function () {
        return this.htmlToMarkdown(this.editor);
      },
      set: function (value) {
        this.editor.innerHTML = this.markdownToHtml(value);
      }
    });
  },
  destroyWidget: function () {
    document.removeEventListener('selectionchange', this._selectionListener);
    window.removeEventListener('scroll', this._repositionListener, true);
    window.removeEventListener('resize', this._repositionListener);
    window.clearTimeout(this._selectionTimer);
    this.popup.remove();
    this.editor.stopObserving();
  },
  stateChange: function () {
    if (!this.editor) return;
    this.editor.contentEditable = this.enabled ? 'true' : 'false';
    if (!this.enabled) this.hidePopup();
  },
  focus: function () {
    this.editor.focus();
  },
  blur: function () {
    this.editor.blur();
  },
  execute: function (command, e) {
    if (e) e.preventDefault();
    if (!this.enabled) return;

    /* Commands reflow the text and shift the selection rect slightly;
       the popup should follow that silently, not fade out and back in.
       Set before execCommand: the input event it fires is synchronous */
    this._commandTime = Date.now();
    this.editor.focus();
    document.execCommand(command, false, null);
    this.onSelectionChange();
    this.onInput();
  },
  onKeyDown: function (e) {
    if (!(e.metaKey || e.ctrlKey)) return;
    var shortcuts = e.shiftKey ? {
      'KeyX': 'strikeThrough',
      'Digit7': 'insertOrderedList',
      'Digit8': 'insertUnorderedList'
    } : {
      'KeyB': 'bold',
      'KeyI': 'italic',
      'KeyU': 'underline'
    };
    if (shortcuts[e.code]) {
      e.preventDefault();
      this.execute(shortcuts[e.code]);
    }
  },
  onPaste: function (e) {
    e.preventDefault();
    var text = (e.clipboardData || window.clipboardData).getData('text/plain');
    if (text) {
      document.execCommand('insertText', false, text);
    }
  },
  onInput: function (e) {
    if (e && e.isComposing) return;

    /* Hide the toolbar while typing so it does not overlap the content;
       it comes back on a click or a new selection. Formatting commands
       also fire real input events, so anything within the command window
       does not count as typing */
    if (e && Date.now() - (this._commandTime || 0) > 200) {
      this._typing = true;
      this.hidePopup();
    }

    /* Keep the editor truly empty so the :empty placeholder shows again */
    if (!this.editor.textContent.trim() && !this.editor.querySelector('li, br + br')) {
      this.editor.innerHTML = '';
    }
    if (this.options.onChange) {
      this.options.onChange(this.value);
    }
  },
  onSelectionChange: function () {
    window.clearTimeout(this._selectionTimer);

    /* Views tear down by removing their DOM wholesale; clean up the
       body-level popup and document listeners when that happens */
    if (!document.body.contains(this.editor)) {
      if (this._wasConnected) this.destroy();
      return;
    }
    this._wasConnected = true;
    if (!this.enabled || !this.hasFocus() || !this.selectionRect()) {
      this.hidePopup();
      return;
    }

    /* While typing the popup stays hidden for a bare caret; selecting
       text (mouse or keyboard) brings it back */
    if (this._typing) {
      if (window.getSelection().isCollapsed) {
        this.hidePopup();
        return;
      }
      this._typing = false;
    }
    this.updateToolbar();
    if (this._popupVisible) {
      /* When the anchor moves, fade out at the old position and back in
         at the new one instead of jumping — unless the move is caused
         by a toolbar command, then just track the reflowed text */
      if (this.hasMoved()) {
        if (Date.now() - (this._commandTime || 0) < 200) {
          this.reposition();
        } else {
          this.hidePopup();
          this._selectionTimer = window.setTimeout(() => this.showPopup(), 200);
        }
      }
    } else {
      /* Wait for the selection to settle so the popup does not chase the
         cursor while dragging */
      this._selectionTimer = window.setTimeout(() => this.showPopup(), 200);
    }
  },
  onBlur: function () {
    /* Delayed: a toolbar click must not dismiss its own popup */
    window.setTimeout(() => {
      if (!this.hasFocus()) {
        this._typing = false;
        this.hidePopup();
      }
    }, 100);
  },
  hasFocus: function () {
    return document.activeElement == this.editor || this.editor.contains(document.activeElement);
  },
  selectionRect: function () {
    /* Not rendered or not visible (e.g. inside a hidden tab): nothing to
       point at. The rect check catches detached and transform-hidden
       editors, checkVisibility the display/visibility/opacity ones */
    var editorRect = this.editor.getBoundingClientRect();
    if (!editorRect.width && !editorRect.height) return null;
    if (this.editor.checkVisibility && !this.editor.checkVisibility({
      checkOpacity: true,
      checkVisibilityCSS: true
    })) return null;
    var selection = window.getSelection();
    if (!selection.rangeCount) return null;
    if (!this.editor.contains(selection.anchorNode) || !this.editor.contains(selection.focusNode)) return null;
    var rect = selection.getRangeAt(0).getBoundingClientRect();
    if (rect.width || rect.height || rect.top || rect.left) return rect;

    /* A caret on an empty line reports a zero rect; anchor to the line
       element instead, or to the top-left of an empty editor */
    var node = selection.anchorNode;
    if (node.nodeType != Node.ELEMENT_NODE) node = node.parentNode;
    if (node == this.editor) {
      return {
        top: editorRect.top + 5,
        bottom: editorRect.top + 23,
        left: editorRect.left + 5,
        width: 0
      };
    }
    return node.getBoundingClientRect();
  },
  showPopup: function () {
    /* Re-validate: focus, enabled state or the selection may have
       changed between scheduling and this timer firing */
    if (!this.enabled || !this.hasFocus()) return;
    if (!this.popup.parentNode) {
      document.body.appendChild(this.popup);
    }
    if (!this.reposition()) return;
    this._popupVisible = true;
    this.popup.classList.add('visible');
  },
  hidePopup: function () {
    window.clearTimeout(this._selectionTimer);
    this._popupVisible = false;
    this.popup.classList.remove('visible');
  },
  computePosition: function () {
    var rect = this.selectionRect();
    if (!rect) return null;
    var width = this.popup.offsetWidth;
    var height = this.popup.offsetHeight;
    var margin = 14;
    var top = rect.top - height - margin;
    var placement = 'top';
    if (top < 4) {
      top = rect.bottom + margin;
      placement = 'bottom';
    }
    var center = rect.left + (rect.width || 0) / 2;
    var left = Math.max(4, Math.min(center - width / 2, window.innerWidth - width - 4));
    return {
      top: top,
      left: left,
      center: center,
      placement: placement
    };
  },
  hasMoved: function () {
    var position = this.computePosition();
    if (!position) return false;
    if (position.placement != this.popup.dataset.placement) return true;
    var top = parseFloat(this.popup.style.top) || 0;
    var left = parseFloat(this.popup.style.left) || 0;

    /* Small reflows do not count as a move: as long as the popup is
       still at the same line and the target is within reach of the
       arrow, leave it where it is */
    if (Math.abs(position.top - top) > 8) return true;
    return position.center < left + 10 || position.center > left + this.popup.offsetWidth - 10;
  },
  reposition: function () {
    var position = this.computePosition();
    if (!position) return false;
    this.popup.style.top = position.top + 'px';
    this.popup.style.left = position.left + 'px';
    this.popup.style.setProperty('--arrow-left', Math.max(10, Math.min(position.center - position.left, this.popup.offsetWidth - 10)) + 'px');
    this.popup.dataset.placement = position.placement;
    return true;
  },
  updateToolbar: function () {
    Object.entries(this._buttons).forEach(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        command = _ref2[0],
        button = _ref2[1];
      var state = false;
      try {
        state = document.queryCommandState(command);
      } catch (e) {}
      button.classList[state ? 'add' : 'remove']('active');
    });
  },
  /* Markdown → HTML */

  markdownToHtml: function (markdown) {
    if (!markdown || !markdown.trim()) return '';

    /* Replace backslash-escaped characters with placeholders so the
       formatting and list regexes below cannot match them */
    markdown = String(markdown).replace(/\\([\\*_~+\-.)])/g, (m, c) => {
      return String.fromCharCode(1 + '\\*_~+-.)'.indexOf(c));
    });
    var html = '';
    var paragraph = [];
    var list = null;
    var inline = text => {
      return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>').replace(/__(.+?)__/g, '<strong>$1</strong>').replace(/\*([^*]+)\*/g, '<em>$1</em>').replace(/_([^_]+)_/g, '<em>$1</em>').replace(/~~(.+?)~~/g, '<del>$1</del>').replace(/\+\+(.+?)\+\+/g, '<u>$1</u>').replace(/[\u0001-\u0008]/g, c => '\\*_~+-.)'.charAt(c.charCodeAt(0) - 1));
    };
    var flush = () => {
      if (paragraph.length) {
        html += '<p>' + paragraph.map(inline).join('<br>') + '</p>';
        paragraph = [];
      }
      if (list) {
        html += '<' + list.type + '>' + list.items.map(i => '<li>' + inline(i) + '</li>').join('') + '</' + list.type + '>';
        list = null;
      }
    };
    markdown.split('\n').forEach(line => {
      var unordered = line.match(/^\s*[-*+]\s+(.*)$/);
      var ordered = line.match(/^\s*\d+[.)]\s+(.*)$/);
      if (unordered || ordered) {
        var type = unordered ? 'ul' : 'ol';
        if (!list || list.type != type) flush();
        list = list || {
          type: type,
          items: []
        };
        list.items.push((unordered || ordered)[1]);
      } else if (!line.trim()) {
        flush();
      } else {
        if (list) flush();
        paragraph.push(line);
      }
    });
    flush();
    return html;
  },
  /* HTML → Markdown */

  htmlToMarkdown: function (root) {
    /* Work on a clone: serializing nested lists detaches nodes and must
       never touch the live editor */
    root = root.cloneNode(true);
    var blocks = [];
    var pending = '';
    var flush = () => {
      var text = pending.replace(/\n{2,}/g, '\n').trim();
      if (text) blocks.push(this.escapeListMarkers(text));
      pending = '';
    };
    var visit = node => {
      if (node.nodeType == Node.TEXT_NODE) {
        pending += this.escapeMarkdownText(node.data.replace(/[\r\n\t]+/g, ' '));
        return;
      }
      if (node.nodeType != Node.ELEMENT_NODE) return;
      switch (node.tagName) {
        case 'BR':
          pending += '\n';
          break;
        case 'UL':
        case 'OL':
          flush();
          blocks.push(this.serializeList(node));
          break;
        case 'P':
        case 'DIV':
        case 'BLOCKQUOTE':
        case 'H1':
        case 'H2':
        case 'H3':
        case 'H4':
        case 'H5':
        case 'H6':
          flush();

          /* Browsers sometimes nest a generated list inside the current
             paragraph; recurse so its lines stay a real list block */
          if (node.querySelector('ul, ol')) {
            [...node.childNodes].forEach(visit);
            flush();
          } else {
            var text = this.serializeInline(node).replace(/\n{2,}/g, '\n').trim();
            if (text) blocks.push(this.escapeListMarkers(text));
          }
          break;
        default:
          if (node.querySelector && node.querySelector('ul, ol')) {
            [...node.childNodes].forEach(visit);
          } else {
            pending += this.serializeInline(node, true);
          }
      }
    };
    [...root.childNodes].forEach(visit);
    flush();
    return blocks.join('\n\n');
  },
  serializeInline: function (node, wrap) {
    var text = '';
    [...node.childNodes].forEach(child => {
      if (child.nodeType == Node.TEXT_NODE) {
        text += this.escapeMarkdownText(child.data.replace(/[\r\n\t]+/g, ' '));
      } else if (child.nodeType == Node.ELEMENT_NODE) {
        if (child.tagName == 'BR') {
          text += '\n';
        } else if (child.tagName == 'UL' || child.tagName == 'OL') {
          text += '\n' + this.serializeList(child) + '\n';
        } else {
          text += this.serializeInline(child, true);
        }
      }
    });
    if (wrap) {
      text = this.wrapInline(node, text);
    }
    return text;
  },
  wrapInline: function (node, text) {
    if (!text.trim()) return text;
    var style = node.style || {};
    var decoration = String(style.textDecoration || style.textDecorationLine || '');
    var markers = [];
    if (node.tagName == 'B' || node.tagName == 'STRONG' || style.fontWeight == 'bold' || parseInt(style.fontWeight, 10) >= 600) markers.push('**');
    if (node.tagName == 'I' || node.tagName == 'EM' || style.fontStyle == 'italic') markers.push('*');
    if (node.tagName == 'U' || decoration.includes('underline')) markers.push('++');
    if (node.tagName == 'S' || node.tagName == 'STRIKE' || node.tagName == 'DEL' || decoration.includes('line-through')) markers.push('~~');

    /* Keep surrounding whitespace outside of the markers */
    var leading = text.match(/^\s*/)[0];
    var trailing = text.match(/\s*$/)[0];
    var inner = text.trim();
    markers.forEach(marker => {
      inner = marker + inner + marker;
    });
    return leading + inner + trailing;
  },
  serializeList: function (node) {
    var ordered = node.tagName == 'OL';
    var lines = [];
    [...node.children].forEach(child => {
      if (child.tagName != 'LI') return;

      /* Serialize nested lists as extra lines at the same level */
      var nested = [...child.querySelectorAll(':scope > ul, :scope > ol')];
      nested.forEach(list => list.remove());
      var text = this.serializeInline(child).replace(/\s+/g, ' ').trim();
      if (text) lines.push((ordered ? lines.length + 1 + '. ' : '- ') + text);
      nested.forEach(list => lines.push(...this.serializeList(list).split('\n')));
    });
    return lines.join('\n');
  },
  escapeMarkdownText: function (text) {
    return text.replace(/\\/g, '\\\\').replace(/([*_~])/g, '\\$1').replace(/\+(?=\+)/g, '\\+');
  },
  escapeListMarkers: function (text) {
    return text.split('\n').map(line => {
      return line.replace(/^(\s*)([-+])(\s)/, '$1\\$2$3').replace(/^(\s*)(\d+)([.)])(\s)/, '$1$2\\$3$4');
    }).join('\n');
  }
});
//# sourceMappingURL=markdowneditor.js.map
